const validate = (attrs = {}) => {
  const errors = {};
  if (!attrs.student || !attrs.student.value) {
    errors.student = 'Debe seleccionar el alumno';
  }

  return errors;
};

export default validate;
